var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotIncl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7421 18.2426C19.0024 17.9822 19.0024 17.5601 18.7421 17.2997L15.4427 14.0004L18.743 10.7001C19.0033 10.4397 19.0033 10.0176 18.743 9.75728C18.4826 9.49693 18.0605 9.49693 17.8002 9.75728L14.4999 13.0576L11.1996 9.75727C10.9392 9.49692 10.5171 9.49692 10.2568 9.75727C9.99644 10.0176 9.99644 10.4397 10.2568 10.7001L13.5571 14.0004L10.2577 17.2997C9.99734 17.5601 9.99734 17.9822 10.2577 18.2426C10.518 18.5029 10.9402 18.5029 11.2005 18.2426L14.4999 14.9432L17.7993 18.2426C18.0596 18.5029 18.4817 18.5029 18.7421 18.2426Z",
    fill: "#4B5768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotIncl);
export default __webpack_public_path__ + "static/media/not-incl.28dd477b9a1fd096afcdb4ab9499c8dc.svg";
export { ForwardRef as ReactComponent };